import type { Price } from '@/types/common';

export function formatPrice(
  price: Price,
  locale = 'en-AU',
  options: Intl.NumberFormatOptions = {
    style: 'currency',
    currency: 'AUD',
  },
) {
  return new Intl.NumberFormat(locale, options).format(Number(price));
}

export function formatAddress({
  address,
  city,
  postCode,
}: {
  address?: string;
  city?: string;
  postCode?: string;
}): string {
  const parsedAddress = address?.split('$$$')[0]?.trim() ?? '';

  return [parsedAddress, city, postCode].filter((part) => !!part && part.trim() !== '').join(', ');
}
